import axios from '../axios'

const axiosUpload = axios.create()

export const uploadFileProgress = async (
	file: File,
	fileType: string,
	onUploadProgress?: (progressEvent: { loaded: number; total?: number }) => void,
	signal: AbortSignal | null = null,
) => {
	const response = await axios.post('files/pre-signed-url', {
		fileType,
		fileSize: file.size,
		fileName: file.name,
	})
	const { upload_url, result_url } = response?.data?.results?.object || {}

	await axiosUpload.put(upload_url, file, {
		headers: {
			'Content-Type': file.type,
			Authorization: undefined,
			'Cache-Control': 'public, max-age=31536000, immutable',
		},
		onUploadProgress: (progressEvent) => {
			onUploadProgress?.(progressEvent)
		},
		...(signal ? { signal } : {}),
	})

	return result_url
}

export const uploadDocFile = async (
	file: File,
	onUploadProgress?: (progressEvent: { loaded: number; total?: number }) => void,
) => {
	const formData = new FormData()
	formData.append('file', file)

	const response = await axios.post('/files/uploadDoc', formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		onUploadProgress: (progressEvent) => {
			onUploadProgress?.(progressEvent)
		},
	})

	return response?.data?.results?.object?.url as string | undefined
}

export const uploadProgress = async (
	file: File,
	onUploadProgress,
	signal = null as any,
) => {
	try {
		return await uploadFileProgress(file, 'image', onUploadProgress, signal)
	} catch (error) {
		console.error('Upload failed:', error)
		throw error
	}
}

export const uploadAudio = async (
	file: File,
	onUploadProgress?: (progressEvent: { loaded: number; total?: number }) => void,
	signal: AbortSignal | null = null,
) => {
	try {
		return await uploadFileProgress(file, 'audio', onUploadProgress, signal)
	} catch (error) {
		console.error('Audio upload failed:', error)
		throw error
	}
}
